<template>
  <form class="flex items-center rounded-full bg-secondary p-1" @submit.prevent>
    <label
      v-for="(option, index) in options"
      :key="option.value + index"
      class="w-full cursor-pointer rounded-full p-1 text-center transition-colors"
      :class="{ 'bg-primary': modelValue.value === option.value }"
    >
      <span class="w-full text-sm text-text-main">{{ option.title }}</span>
      <input
        type="radio"
        :name
        :value="option"
        :checked="modelValue.value === option.value"
        class="size-0 shrink-0 opacity-0"
        @change="$emit('update:modelValue', option)"
      />
    </label>
  </form>
</template>

<script lang="ts" setup generic="T extends { value: string; title: string }">
defineProps<{
  modelValue: T
  options: T[]
  name: string
}>()
defineEmits<{
  (e: 'update:modelValue', value: T): void
}>()
</script>
